/**
 * Sistema de Eventos para Comunicação de Mensagens em Tempo Real
 * 
 * Este sistema permite que componentes se registrem para receber notificações
 * de novas mensagens sem criar dependências circulares entre hooks.
 */

import { Message } from '../types/communication.types'

export interface MessageEvent {
  sessionKey: string
  message: Message
  guestName: string
  unreadCount: number
}

type MessageEventHandler = (event: MessageEvent) => void

class MessageEventBus {
  private handlers: Set<MessageEventHandler> = new Set()

  /**
   * Registrar um handler para receber eventos de novas mensagens
   */
  subscribe(handler: MessageEventHandler): () => void {
    this.handlers.add(handler)
    console.log(`✅ [EventBus] Handler registrado. Total: ${this.handlers.size}`)
    
    // Retornar função de cleanup
    return () => {
      this.handlers.delete(handler)
      console.log(`❌ [EventBus] Handler removido. Total: ${this.handlers.size}`)
    }
  }

  /**
   * Publicar um evento de nova mensagem para todos os handlers registrados
   */
  publish(event: MessageEvent): void {
    console.log(`📢 [EventBus] Publicando evento:`, {
      sessionKey: event.sessionKey,
      messageId: event.message.id,
      messageAuthor: event.message.author,
      messageText: event.message.text?.substring(0, 50),
      handlersCount: this.handlers.size
    })
    
    if (this.handlers.size === 0) {
      console.warn('⚠️ [EventBus] Nenhum handler registrado! Mensagem será perdida.')
    }
    
    let handlerIndex = 0
    this.handlers.forEach((handler) => {
      handlerIndex++
      try {
        console.log(`📤 [EventBus] Enviando para handler ${handlerIndex}/${this.handlers.size}`)
        handler(event)
        console.log(`✅ [EventBus] Handler ${handlerIndex} processou com sucesso`)
      } catch (error) {
        console.error(`❌ [EventBus] Erro no handler ${handlerIndex}:`, error)
      }
    })
  }

  /**
   * Obter número de handlers registrados (para debug)
   */
  getHandlerCount(): number {
    return this.handlers.size
  }
}

// Instância singleton
export const messageEventBus = new MessageEventBus()